module.exports = __webpack_public_path__ + "static/media/YashMv3.cb386e8d.png";